/**
 * 页面入口，页面单独作为一个组件
 */
 import React, { Component } from 'react';
 import ReactDOM from 'react-dom';
 import {
     Router,
     Route,
     Switch
 } from 'react-router-dom';
 import Routes from './routes';
 import Provider from 'services/provider';
 import Store from 'services/store';
import './index.less';
import 'antd/dist/antd.css'; 
 
 import reportWebVitals from './../reportWebVitals';
 import { createBrowserHistory } from 'history'
 const history = createBrowserHistory()
 
 
 ReactDOM.render(
     
     <Provider store={Store}>
      <Router history={history}>
                     <div>
                         <Switch>
                             {
                                 Routes.map((route, n) => (
                                     <Route key={n} {...route} />
                                 ))
                             }
                         </Switch>
                     </div>
         </Router>
     </Provider>,
    
     document.getElementById('root')
   );
   
   
 reportWebVitals();
 
 
 
 
 
 